import ModalRenameProject from './ModalRenameProject';

export default ModalRenameProject;
